import { Navigate } from 'react-router-dom';
import { getToken } from '../modules';

export const PublicRoute = ({ children }) => {
    return getToken()
        ? <Navigate to="/"/>
        : children
}
